import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { IonItem, IonInput, IonButton, IonSpinner } from "@ionic/angular/standalone";
import { CommonModule } from '@angular/common';
import { isPlatform } from '@ionic/angular';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: true,
  imports: [IonSpinner, IonButton, IonInput, IonItem, CommonModule, FormsModule, ReactiveFormsModule]
})
export class ChangePasswordComponent {

  fb = inject(FormBuilder);
  authService = inject(AuthService);
  router = inject(Router);
  route = inject(ActivatedRoute);

  alteraSenhaForm: FormGroup;

  mensagem: string = '';
  identificador: string = '';
  loading = false;
  origem: string = 'login';

  showNewPassword = false;
  showConfirmPassword = false;

  constructor() {
    this.alteraSenhaForm = this.fb.group({
      senha: ['', [Validators.required, Validators.minLength(6)]],
      confirmaSenha: ['', [Validators.required, Validators.minLength(6)]]
    });
    this.route.queryParams.subscribe(params => {
      this.identificador = params['identificador'] || '';
      this.origem = params['origem'] || 'login';
    });
  }

  /*alterarSenha() {
    if (this.alteraSenhaForm.valid) {
      const senha = this.alteraSenhaForm.get('senha')?.value;
      const confirmaSenha = this.alteraSenhaForm.get('confirmaSenha')?.value;

      if (senha === confirmaSenha) {
        this.loading = true;
        this.authService.alterarSenha(this.identificador, senha).subscribe({
          next: async () => {
            this.loading = false;
            this.mensagem = 'Senha alterada com sucesso!';

            // Faz login para obter o token
            const token: string = await this.authService.login(this.identificador, senha);

            if (isPlatform('hybrid')) {
              // 🔑 Faz login automático no app
              const token: string = await this.authService.login(this.identificador, senha);
              const decoded: any = jwtDecode(token);
              const role = decoded.authorities?.[0] || '';

              if (role === 'ROLE_GERENTE') {
                this.router.navigate(['/gerente']);
              } else if (role === 'ROLE_MOTORISTA') {
                this.router.navigate(['/motorista']);
              } else {
                this.router.navigate(['/url-servico']);
              }
            } 
            
            else {
              //this.router.navigate(['/first-page']);

              sessionStorage.setItem('token', token);
              sessionStorage.setItem('matricula', this.identificador);
              
              // Força recarregamento da página
              window.location.href = '/first-page';
            }
          },
          error: () => {
            this.loading = false;
            this.mensagem = 'Erro ao alterar a senha. Tente novamente.';
          }
        });
      } else {
        this.mensagem = 'As senhas não correspondem.';
      }
    } else {
      this.mensagem = 'Preencha o formulário corretamente.';
    }
  }*/

  alterarSenha() {
    if (this.alteraSenhaForm.valid) {
      const senha = this.alteraSenhaForm.get('senha')?.value;
      const confirmaSenha = this.alteraSenhaForm.get('confirmaSenha')?.value;

      if (senha === confirmaSenha) {
        this.loading = true;
        this.authService.alterarSenha(this.identificador, senha).subscribe({
          next: async () => {
            this.loading = false;
            this.mensagem = 'Senha alterada com sucesso!';

            // Faz login para obter o token
            const token: string = await this.authService.login(this.identificador, senha);

            if (isPlatform('hybrid')) {
              const decoded: any = jwtDecode(token);
              const role = decoded.authorities?.[0] || '';

              if (role === 'ROLE_GERENTE') {
                this.router.navigate(['/gerente']);
              } else if (role === 'ROLE_MOTORISTA') {
                this.router.navigate(['/motorista']);
              } else {
                this.router.navigate(['/url-servico']);
              }
            } else {
              // 🔥 DECIDE PARA ONDE REDIRECIONAR BASEADO NA ORIGEM
              if (this.origem === 'first-page') {
                // Veio do first-page, volta para o first-page
                sessionStorage.setItem('token', token);
                sessionStorage.setItem('matricula', this.identificador);
                window.location.href = '/first-page';
              } else {
                // Veio do login, volta para o login
                sessionStorage.setItem('token', token);
                sessionStorage.setItem('matricula', this.identificador);
                window.location.href = '/auth/login?retaguarda=true';
              }
            }
          },
          error: () => {
            this.loading = false;
            this.mensagem = 'Erro ao alterar a senha. Tente novamente.';
          }
        });
      } else {
        this.mensagem = 'As senhas não correspondem.';
      }
    } else {
      this.mensagem = 'Preencha o formulário corretamente.';
    }
  }

  toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

}
